<template>
  <div class="kj-join">
    <ParticipatorList :player="player" :id="id" @isShow="handleShowchange"></ParticipatorList>
    <yd-popup v-model="contentShow" position="bottom" height="auto">
      <div class="kj-join-tips">
        <button class="kj-join-close" @click="contentShow=false"><img src="./close.svg"></button>
        <h2 class="kj-join-tips_title">活动说明</h2>
        <div class="kj-join-tips_cont" v-html="formatTerms"></div>
      </div>
    </yd-popup>
  </div>
</template>
<script>
  import ParticipatorList from 'base/participatorList'

  export default {
    data () {
      return {
        contentShow: false
      }
    },
    props: ['player', 'id', 'terms'],
    computed: {
      formatTerms: function () {
        const formatTerms = this.terms.replace(/\n/g, `<br>`)
        return formatTerms
      }
    },
    methods: {
      handleShowchange () {
        this.contentShow = true
      }
    },
    components: {
      ParticipatorList
    }
  }
</script>
<style scoped>
.kj-join-tips {
  position: relative;
}
.kj-join-tips_title {
  margin: 0 0 16px;
  padding: 16px 15px;
  border: 0 solid #ddd;
  border-width: 0 0 .5px;
  font-size: 20px;
  line-height: 1;
}
.kj-join-close {
  position: absolute;
  top: 3px;
  right: 0;
  box-sizing: content-box;
  display: block;
  margin: 0;
  padding: 15px;
  background: transparent;
  border: none;
  font-size: 0;
  line-height: 1;
  height: auto;
  width: auto;
  color: #333
}
.kj-join-close img {
  display: block;
  max-width: 15px;
  max-height: 15px;
}
.kj-join-tips_cont {
  padding: 0 15px 70px;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// index.vue?69cf5ff6